import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Integration, IntegrationType } from '@pdqdev/pdq-shared/dist/entities';
import { IntegrationsService } from '@services/integrations/integrations.service';
import { ShopService } from '@app/services/shops/shop.service';

@Component({
  selector: 'order-protection-settings',
  templateUrl: './order-protection-settings.component.html',
  styleUrls: ['./order-protection-settings.component.scss'],
  standalone: false,
})
export class OrderProtectionSettingsComponent implements OnInit {
  @Input() integrationType?: IntegrationType;
  @Input() integration?: Integration;

  storeId: string = '';
  storeDomain: string = '';
  applicationId: string = '';

  private destroyRef = inject(DestroyRef);

  constructor(
    private integrationService: IntegrationsService,
    private shopService: ShopService,
  ) {}

  ngOnInit(): void {
    this.storeDomain = this.shopService.currentShopValue?.name ?? '';
    this.integrationService.integrations$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((integrations) => {
      if (!this.integrationType) return;
      this.integration = integrations[this.integrationType.name]?.instance;
      this.storeId = this.integration?.metadata?.orderProtection?.storeId ?? '';
      this.applicationId = this.integration?.metadata?.orderProtection?.applicationId ?? '';
    });
  }
}
